"use client";
import {
  DialogContextProvider,
  DialogScopedContextProvider
} from "./T2AZQXQU.js";
import {
  createStoreContext
} from "./VOQWLFSQ.js";

// src/popover/popover-context.tsx
var ctx = createStoreContext(
  [DialogContextProvider],
  [DialogScopedContextProvider]
);
var usePopoverContext = ctx.useContext;
var usePopoverScopedContext = ctx.useScopedContext;
var usePopoverProviderContext = ctx.useProviderContext;
var PopoverContextProvider = ctx.ContextProvider;
var PopoverScopedContextProvider = ctx.ScopedContextProvider;

export {
  usePopoverContext,
  usePopoverScopedContext,
  usePopoverProviderContext,
  PopoverContextProvider,
  PopoverScopedContextProvider
};
